export default __webpack_public_path__ + "static/media/banner_ihelp.c0f0c930.jpg";